export class StatementRemarks {

    PatientStatementId: number;
    Remarks: string;

    constructor() {
    }
}